import type { I18nFn } from '#/i18n/types/I18nFn';

export function getBaseFilePickerDefaultMessage(i18n: I18nFn) {
  return i18n('Choose a file or drag it here');
}

export function getBaseFilePickerHelpText(
  i18n: I18nFn,
  maxSizeInMB: number | null,
) {
  if (maxSizeInMB) {
    return i18n('No file chosen (maximum size: %(maxSize)s MB)', {
      maxSize: maxSizeInMB,
    });
  }

  return i18n('No file chosen');
}
